/**
 * @private-doc
 */
export type PortalUrlValues =
  | 'https://www.pbcgov.org'
  | 'http://webtrain01.pbcgov.org'
  | 'http://webqa01.pbcgov.org'
  | 'http://webdev01.pbcgov.org'
  | 'http://localhost:4200'
/**
 * @private-doc
 */
export class PortalUrl {
  public static readonly DEV: PortalUrlValues = 'http://webdev01.pbcgov.org'
  public static readonly TRAINING: PortalUrlValues = 'http://webtrain01.pbcgov.org'
  public static readonly QA: PortalUrlValues = 'http://webqa01.pbcgov.org'
  public static readonly PROD: PortalUrlValues = 'https://www.pbcgov.org'
}
